<template>
  <div class="animated fadeIn">
        <b-card>
            <div slot="header">
                Absent Permit Form (Izin tdk Hadir)
              <div class="card-header-actions">
                <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
                  <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
              </div>
            </div>
            <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Employee</label></b-input-group-prepend>
                      <b-form-input v-model="model.crewinfo" readonly :state="!$v.model.crewkey.$error"></b-form-input>
                        <b-input-group-append v-if="(this.absentpermitMenu!='hrm.absentpermitself')">
                        <b-btn text="Button" @click="lkuCrewShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Job Title</label></b-input-group-prepend>
                      <b-form-input v-model="model.jabatan" placeholder="Job Title" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Department</label></b-input-group-prepend>
                        <b-form-input v-model="model.departemen" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Location</label></b-input-group-prepend>
                        <b-form-input v-model="model.location" disabled></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Project</span></b-input-group-prepend>
                        <b-form-input readonly v-model="model.projectname" ></b-form-input>
                    </b-input-group>

                </b-col>
                <b-col lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label>Permit Date</label></b-input-group-prepend>
                      <b-form-input v-model="model.TakenDate" type='date' :state="!$v.model.TakenDate.$error"></b-form-input>
                      <b-input-group-prepend><span class="input-group-text" >Permit Time</span> </b-input-group-prepend>
                      <b-input-group-append>
                      <b-form-input v-model="model.StartTime" type='time' :state="!$v.model.StartTime.$error"></b-form-input>
                        <b-input-group-prepend><span class="input-group-text" >until</span> </b-input-group-prepend>
                      <b-form-input v-model="model.EndTime" type='time' :state="!$v.model.EndTime.$error"></b-form-input>
                        </b-input-group-append>
                </b-input-group>
                    <b-input-group >
                      <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                        <b-form-textarea v-model="model.TakenReason" :state="!$v.model.TakenReason.$error" rows="2" max-rows="4"></b-form-textarea>
                    </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Job Delegate To</label></b-input-group-prepend>
                    <b-form-input v-model="model.delegateTo" placeholder="Delegasi tugas saat cuti" ></b-form-input>
                  </b-input-group>

                </b-col>
            </b-row>
            <hr>
            <b-row class="justify-content-center">
                        <button  v-if="saveEnabled" class="btn btn-primary ml-2 mr-1" @click.stop="save()"><i class="fa fa-save"></i> Save</button>
                        <b-button class="btn btn-primary mr-2" @click.stop="close()" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>
        </b-card>
        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew"></lku-crew>
        </b-modal>        
  </div>
</template>
<style lang="scss">
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;
        min-height: 100px;
        border: 1px solid silver;
        table {
            font-size: smaller;
            th {
                border: 1px solid silver;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            td {
                border: 1px solid silver;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
        }
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group {
            padding-bottom:2px;
            .input-group-prepend {
                label {
                    padding-top: 5px;
                    padding-right: 5px;
                    width: 90px;
                }
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>
<script>
// import VueClockPicker from 'vue-clock-picker';
import moment from 'moment';
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import absentpermit from "../../apis/absentpermit";
import lkuCrew from "../lookup/lkuCrew";
import toastr from "mini-toastr";
toastr.init();

export default {   
  // components:{myNumber,lkuCrew, VueClockPicker },
  components:{myNumber,lkuCrew },
  mixins: [validationMixin],
  validations: {
        model: {
            crewkey: { required },
            TakenDate: {required },
            TakenReason: { required },
            StartTime: { required },
            EndTime: { required },
        },
  }, 
  data () {
    return {
        horizontal:true,
        saveEnabled:true,
        absentpermitMenu:'',
        user: this.$store.state.user,
        model:{crewkey: '',TakenDate:'', StartTime:'',EndTime: '',TakenReason: '' },
        lkuCrewShow:false,
        currency:[{value:'IDR',text:'IDR'}],
    }
  },
  computed: {
      invalidModel() {
        this.$v.model.$touch();
        return this.$v.model.$invalid;
      },
  },
  created: async function(){
      this.absentpermitMenu = localStorage.getItem('absentpermitMenu');
      console.log('this.absentpermitMenu: ', this.absentpermitMenu);
      if (this.$route.params.absentkey)  {
          toastr.info('Loading Leave Detail, please wait')
          try {
            const data = await absentpermit.detail(this.$route.params) ;
            const row = data[0];
            for (var key in row) {
                this.model[key] = row[key];
            }
        this.model.TakenDate=moment(row.TakenDate).format('YYYY-MM-DD');

            toastr.clear;
          } catch (error) {
              console.log('error : ', error);
              toastr.error(JSON.stringify(error), "Error Info",10000);                              
          }
      } else {
        this.model.TakenDate=moment().format('YYYY-MM-DD');
        if (this.absentpermitMenu=='hrm.absentpermitself') {
          this.model.crewinfo = this.user.full_name.trim() + ' | ' + this.user.crewnik;
          this.model.crewkey=this.user.crewkey;
          this.model.crewname=this.user.full_name;
          this.model.crewnik=this.user.crewnik;
          this.model.jabatan=this.user.jabatan;
          this.model.departemen=this.user.departemen;
        }

      }
  },
  methods:{
    onSelectLkuCrew: async function (_selected) {
        this.model.crewinfo = _selected.crewname.trim() + ' | ' + _selected.crewnik.trim();
            for (var key in _selected) {
                this.model[key] = _selected[key];
            }        
        this.lkuCrewShow=false;
    },
    save: async function(){
        console.log('this.model: ', this.model);
        if (this.invalidModel) {
            console.log('validation  : ', this.$v.model);
            console.log('model : ',this.model);
            toastr.error('Please fill the form correctly.', "Error Info");
       } else {
            try {
              const data={};
              for (var key in this.model) {
                  data[key] = this.model[key];
              }     
              data.TakenDate = moment(this.model.TakenDate).format('YYYY-MM-DD');

              await absentpermit.save(data);
              this.close();
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message, "Error Info",10000);
                } else {
                    toastr.error(JSON.stringify(error), "Error Info",10000);
                }              
            }
        }
    },
    close(){
      if (this.absentpermitMenu=='hrm.absentpermitself')  router.push({name: 'hrm.absentpermitself'});
      else  router.push({name: 'hrm.absentpermit'});
    },    
  }
}
</script>